<template>
  <div>
    <title-bar title="单位日汇总统计表">
      <el-button @click="$router.back()" icon="fa fa-angle-left">返回</el-button>
    </title-bar>
    <div class="page-body">
      <el-form inline>
        <el-form-item label="单位">
          <comp-select v-model="queryForm.compIds" multiple collapse-tags style="width: 300px"></comp-select>
        </el-form-item>
        <el-form-item label="统计日期">
          <el-date-picker v-model="queryForm.startDate" type="date"
                          placeholder="开始日期"
                          :clearable="false"
                          style="width: 140px"
                          value-format="yyyy-MM-dd"></el-date-picker>
          至
          <el-date-picker v-model="queryForm.endDate" type="date"
                          placeholder="结束日期"
                          :clearable="false"
                          style="width: 140px"
                          value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-button type="primary" icon="fa fa-search" :loading="loading" @click="query">查询</el-button>
        <el-button type="primary" icon="fa fa-download" :loading="loading" @click="download">导出</el-button>
      </el-form>

      <el-table stripe :data="records" :border="true" v-loading="loading">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="compName" label="单位名称" min-width="180"></el-table-column>
        <el-table-column label="空调运行统计（小时）" align="center">
          <el-table-column prop="acRunHours" label="总时长" align="center" min-width="90"></el-table-column>
          <el-table-column prop="acAvgHours" label="设备日均运行" align="center" min-width="120"></el-table-column>
        </el-table-column>
        <el-table-column label="新风运行统计（小时）" align="center">
          <el-table-column prop="fanRunHours" label="总时长" align="center" min-width="90"></el-table-column>
          <el-table-column prop="fanAvgHours" label="设备日均运行" align="center" min-width="120"></el-table-column>
        </el-table-column>
      </el-table>
      <table-pagination :page-query="queryForm" :total="total" @change="loadData"></table-pagination>
    </div>
  </div>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
import CompSelect from "@/components/base/CompSelect.vue";
import * as querystring from "querystringify";
export default {
  components: {CompSelect, TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      queryForm: {
        compIds: '',
        startDate: new Date().format("yyyy-MM")+"-01",
        endDate: new Date().format("yyyy-MM-dd"),
        page: 1,
        limit: 10
      },
      total: 0,
      records: []
    }
  },
  created() {
    this.query();
  },
  methods: {
    query(){
      this.queryForm.page = 1;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.postForm("/report/workTimeReport", this.queryForm, true).then(dr => {
        this.records = dr.rows;
        this.total = dr.total;
      }).finally(()=>{
        this.loading = false;
      })
    },
    download() {
      let params = querystring.stringify(this.queryForm || {});
      window.open(this.globalConfig.apiRoot+"/report/exportWorkTimeReport?"+params);
    }
  }
}
</script>

<style scoped>

</style>